(function () {
  var modal;
  var player;
  var lastTrigger;

  function resolve() {
    modal = document.getElementById('video-modal');
    player = modal ? modal.querySelector('[data-video-modal-player]') : null;
    return !!player;
  }

  function close() {
    if (!modal || !modal.open) return;
    modal.close();
  }

  function open(src, label) {
    if (!resolve() || !src) return;
    player.src = src;
    if (label) modal.setAttribute('aria-label', label);
    modal.showModal();
    document.documentElement.style.overflow = 'hidden';
    var playback = player.play();
    if (playback && typeof playback.catch === 'function') playback.catch(function () {});
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-video-modal-src]');
    if (trigger) {
      event.preventDefault();
      lastTrigger = trigger;
      open(trigger.getAttribute('data-video-modal-src'), trigger.getAttribute('data-video-modal-label'));
      return;
    }
    if (event.target.closest('[data-video-modal-close]')) {
      close();
      return;
    }
    if (modal && modal.open && event.target === modal) close();
  });

  document.addEventListener('close', function (event) {
    if (event.target !== modal) return;
    player.pause();
    player.removeAttribute('src');
    player.load();
    document.documentElement.style.overflow = '';
    if (lastTrigger && document.contains(lastTrigger)) lastTrigger.focus();
    lastTrigger = null;
  }, true);
})();
